import {ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
// Include Component
import {AppConfigs} from "./app.config";
import {LoginComponent} from './_components/login/login.component';
import {LogoutComponent} from './_components/logout/logout.component';
import {DashboardComponent} from './_components/dashboard/dashboard.component';
// Include Layout
import {AdminComponent} from './_layouts/admin/admin.component';
import {UserComponent} from './_components/user/user.component';
import {ChangePasswordComponent} from './_components/user/changepassword/changepassword.component';
import {CoinConfigComponent} from './_components/coinconfig/coinconfig.component';
import {CoinEventsComponent} from './_components/coinevents/coinevents.component';
import {LineGroupComponent} from './_components/linegroup/linegroup.component';
import {LineBotAccountComponent} from './_components/line-bot-account/line-bot-account.component';
import {MessageComponent} from './_components/message/message.component';
import {LineUserComponent} from './_components/line-user/line-user.component';
import {TradeHistoryComponent} from './_components/trade-history/trade-history.component';
import {CrossPointsComponent} from './_components/cross-points/cross-points.component';
import {IosAppUsersComponent} from './_components/ios-app-user/ios-app-user.component';
import {IosUserChannelComponent} from './_components/ios-user-channel/ios-user-channel.component';
import {IosUserEventComponent} from './_components/ios-user-event/ios-user-event.component';
import {CoinCandlestickConditionComponent} from "./_components/coin-candlestick-condition/coin-candlestick-condition/coin-candlestick-condition.component";
import {CandlestickConditionDefaultComponent} from './_components/candlestick-condition-default/candlestick-condition-default.component';
import {RegisterComponent} from "./_components/register/register.component";
import {AuthGuard} from "./_services/auth/auth-guard.service";
import {RoleLoginGuardService} from "./_services/auth/role-login-guard.service";
import {ForgotComponent} from "./_components/forgot/forgot.component";
import {ConfirmPasswordComponent} from "./_components/forgot/confirm-password/confirm-password.component";
import {ProfileUserComponent} from "./_components/user/profile-user/profile-user.component";
import {EmaComponent} from "./_components/ema/ema.component";
import {TwitterComponent} from "./_components/twitter/twitter.component";
import {MailTemplateComponent} from './_components/mail-template/mail-template.component';
import {TelegramChannelComponent} from "./_components/telegram-channel/telegram-channel.component";
import {ModulesComponent} from "./_components/modules/modules.component";
import {UserWebIosComponent} from "./_components/user-web-ios/user-web-ios.component";
import {ModulesFunctionsComponent} from "./_components/modules-functions/modules-functions.component";
import {CategoryMoneyComponent} from "./_components/category-money/category-money.component";
import {AutoTradeCoinConfigComponent} from './_components/auto-trade-coin-config/auto-trade-coin-config.component';
import {BinanceApiComponent} from './_components/binance-api/binance-api.component';
import {AutoTradeHistoryComponent} from './_components/auto-trade-history/auto-trade-history.component';
import {SendSignalEventComponent} from "./_components/send-signal-event/send-signal-event.component";
import {UserQuestionsComponent} from "./_components/user-questions/user-questions.component";
import {ManageCoinInCmcComponent} from "./_components/send-signal-event/manage-coin-in-cmc/manage-coin-in-cmc.component";
import {ManageCoinSendForUserComponent} from "./_components/send-signal-event/manage-coin-send-for-user/manage-coin-send-for-user.component";
import {CoinSendPriceUserComponent} from "./_components/send-signal-event/coin-send-price-user/coin-send-price-user.component";

const appRoutes: Routes = [
    {
        path: '',
        canActivateChild: [AuthGuard],
        component: AdminComponent,
        children: [
            {
                path: '',
                redirectTo: 'coin',
                pathMatch: 'full'
            },
            // { path: '', component: DashboardComponent },
            {
                path: 'user',
                canActivate: [RoleLoginGuardService],
                component: UserComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'mail-template',
                canActivate: [RoleLoginGuardService],
                component: MailTemplateComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'user/changepassword', component: ChangePasswordComponent
            },
            {
                path: 'coin',
                component: CoinConfigComponent,
                data: {existConnect: AppConfigs.ACL_U1}
            },
            {
                path: 'coinevents',
                canActivate: [RoleLoginGuardService],
                component: CoinEventsComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'linegroup',
                canActivate: [RoleLoginGuardService],
                component: LineGroupComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'lineuser',
                canActivate: [RoleLoginGuardService],
                component: LineUserComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'message',
                canActivate: [RoleLoginGuardService],
                component: MessageComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'tradehistory',
                canActivate: [RoleLoginGuardService],
                component: TradeHistoryComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'cross-points',
                canActivate: [RoleLoginGuardService],
                component: CrossPointsComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'line-bot-account',
                canActivate: [RoleLoginGuardService],
                component: LineBotAccountComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'ios-app-users',
                canActivate: [RoleLoginGuardService],
                component: IosAppUsersComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'ios-users-channel',
                canActivate: [RoleLoginGuardService],
                component: IosUserChannelComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'ios-users-event',
                canActivate: [RoleLoginGuardService],
                component: IosUserEventComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'coin-candlestick-condition',
                canActivate: [RoleLoginGuardService],
                component: CoinCandlestickConditionComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'candlestick',
                canActivate: [RoleLoginGuardService],
                component: CandlestickConditionDefaultComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'ema',
                canActivate: [RoleLoginGuardService],
                component: EmaComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'profile-user',
                component: ProfileUserComponent
            },
            {
                path: 'twitter',
                component: TwitterComponent,
                data: {existConnect: AppConfigs.ACL_U1, path: 'twitter'}
            },
            {
                path: 'telegram-channel',
                canActivate: [RoleLoginGuardService],
                component: TelegramChannelComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'modules',
                canActivate: [RoleLoginGuardService],
                component: ModulesComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'user-web-ios',
                canActivate: [RoleLoginGuardService],
                component: UserWebIosComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'modules-functions',
                canActivate: [RoleLoginGuardService],
                component: ModulesFunctionsComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'category-money',
                canActivate: [RoleLoginGuardService],
                component: CategoryMoneyComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'auto-trade-coin-config',
                canActivate: [RoleLoginGuardService],
                component: AutoTradeCoinConfigComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'binance-api',
                canActivate: [RoleLoginGuardService],
                component: BinanceApiComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'auto-trade-history',
                canActivate: [RoleLoginGuardService],
                component: AutoTradeHistoryComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'send-signal-event',
                canActivate: [RoleLoginGuardService],
                component: SendSignalEventComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'manage-coin-in-cmc',
                canActivate: [RoleLoginGuardService],
                component: ManageCoinInCmcComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'manage-coin-send-for-user',
                canActivate: [RoleLoginGuardService],
                component: ManageCoinSendForUserComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            },
            {
                path: 'coin-send-price-user',
                canActivate: [RoleLoginGuardService],
                component: CoinSendPriceUserComponent,
                data: {expectedRole: [AppConfigs.ACL_AD], existConnect: AppConfigs.ACL_U1}
            },
            {
                path: 'user-questions',
                canActivate: [RoleLoginGuardService],
                component: UserQuestionsComponent,
                data: {expectedRole: [AppConfigs.ACL_U1]}
            }
        ]
    },
    {
        path: 'login',
        canActivate: [RoleLoginGuardService],
        component: LoginComponent
    },
    {
        path: 'logout',
        component: LogoutComponent
    },
    {
        path: 'register',
        canActivate: [RoleLoginGuardService],
        component: RegisterComponent
    },
    {
        path: 'forgot',
        canActivate: [RoleLoginGuardService],
        component: ForgotComponent
    },
    {
        path: 'confirm-forgot/:token_pwd',
        canActivate: [RoleLoginGuardService],
        component: ConfirmPasswordComponent
    },
    // otherwise redirect to home
    {
        path: '**',
        redirectTo: ''
    }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/app.routing.ts